import { Map } from "immutable";
import { resolveEach } from "redux-resolver";
import * as actionTypes from "MODULES/SalesOrders/actionTypes";

export const initialState = Map({
  salesOrderWithAllLineItems: Map()
});

function setSalesOrderWithAllLineItems(state, action) {
  return state.merge({
    salesOrderWithAllLineItems: action.salesOrderWithAllLineItems
  });
}

export default resolveEach(initialState, {
  [actionTypes.SET_SALES_ORDER_WITH_ALL_LINE_ITEMS]: setSalesOrderWithAllLineItems
});



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/salesOrderWithAllLineItemsReducer.js